import {
  CardListItem,
  Button,
  Typography,
  CircularProgress, 
} from "@ann/web-components";
import { Icon } from "@ann/web-components";
import {
  FirstColumnWrapper,
  ColumnWrapper,
  RowWrapper,
  ActionWrapper,
  IconWrapper,
  EmptyStateWrapper
} from "../../RecentActivity.styled";

const TYPE_CONFIG = {
  Email: {
    icon: "email",
    cols: (item) => [
      { label: "Sender", value: item.sender },
      { label: "Opens", value: item.opens },
      { label: "Clicks", value: item.clicks },
      { label: "Timestamp", value: item.timestamp },
    ],
  },
  Notes: {
    icon: "description",
    cols: (item) => [
      { label: "Description", value: item.description },
      { label: "Category", value: item.category },
      { label: "Owner", value: item.owner },
      { label: "Last Update", value: item.lastUpdated },
    ],
  },
  SMS: {
    icon: "chat",
    cols: (item) => [
      { label: "From", value: item.From },
      { label: "To", value: item.To },
      { label: "Replies", value: item.Replies },
      { label: "Timestamp", value: item.timestamp },
    ],
  },
};

const RecentActivityContent = ({ items = [], loading, error, onRetry }) => {
  if (loading && items.length === 0) {
    return (
      <EmptyStateWrapper>
        <CircularProgress size="small" />
      </EmptyStateWrapper>
    );
  }

  if (error) {
    return (
      <EmptyStateWrapper>
        <Typography category="body" weight="regular" size="medium" color="body">
          We couldn’t load recent activities.
        </Typography>
        <Button
          label="Try again"
          size="small"
          type="primary"
          onClick={onRetry}
        />
      </EmptyStateWrapper>
    );
  }

  if (!items.length) {
    return (
      <EmptyStateWrapper>
        <Typography category="body" weight="regular" size="medium" color="body">
          No recent activities to show yet.
        </Typography>
      </EmptyStateWrapper>
    );
  }

  return (
    <CardListItem>
      {items.map(({ type, data, id }) => {
        const config = TYPE_CONFIG[type] || TYPE_CONFIG.Notes;
        const columns = config.cols(data).map(({ value, ...rest }) => ({
          value: value ?? "-",
          ...rest,
        }));

        return (
          <CardListItem.Row key={id}>
            <CardListItem.RowContent>
              <RowWrapper>
                <FirstColumnWrapper className="col-1">
                  <IconWrapper>
                    <Icon name={config.icon} size="medium" />
                  </IconWrapper>
                  <Typography category="subtitle" weight="bold" size="small">
                    {data.title}
                  </Typography>
                </FirstColumnWrapper>

                {columns.map(({ label, value }, idx) => (
                  <ColumnWrapper key={idx} className={`col-${idx + 2}`}>
                    <Typography category="subtitle" weight="bold" size="small">
                      {label}
                    </Typography>
                    <Typography
                      category="body"
                      weight="regular"
                      size="medium"
                      color="body"
                    >
                      {value}
                    </Typography>
                  </ColumnWrapper>
                ))}
              </RowWrapper>
            </CardListItem.RowContent>

            <CardListItem.RowActions>
              <ActionWrapper>
                <Button
                  size="small"
                  type="primary"
                  icon="arrowRight"
                  pill={true}
                />
              </ActionWrapper>
            </CardListItem.RowActions>
          </CardListItem.Row>
        );
      })}
    </CardListItem>
  );
};

export default RecentActivityContent;
